<template>
  <b-button
    class="btn-shift-data ml-2"
    @click="handleClicked"
  >
    <font-awesome-icon
      icon="download"
      class="icon-style"
    />
    シフト表（Excel）
  </b-button>
</template>

<script>
import axios from 'axios';

export default {
  name: 'BtnShiftExcelDownload',
  props: {
    year: {
      type: String,
      default: 0,
    },
    month: {
      type: String,
      default: 0,
    },
    officeId: {
      type: Number,
      default: 0,
    },
    officeName: {
      type: String,
      default: '',
    },
    teamId: {
      type: Number,
      default: 0,
    },
    teamName: {
      type: String,
      default: '',
    },
  },
  methods: {
    updateLoading(flg) {
      EventBus.$emit('updateLoading', flg);
    },
    async handleClicked() {
      const { isConfirmed, value: rowCount } = await this.selectRowCountSwal();

      if (!isConfirmed) {
        return;
      }

      this.updateLoading(true);

      try {
        const res = await this.downloadExcel(rowCount);
      } catch (error) {
        this.swalErrorAlert();
        console.error(error);
      }finally{
        this.updateLoading(false);
      }
    },
    selectRowCountSwal() {
      // セレクトボックスのオプションを生成
      const inputOptions = [...Array(5).keys()].reduce(
        (acc, cur) => {
          cur++;
          acc[String(cur)] = `${cur}行`;

          return acc;
        },
        { 0: '空行なし' }
      );

      return this.$swal({
        html: 'シフトをダウンロードします。よろしいですか？各職員に対しての空行（メモ等にご利用ください）が必要な場合は以下より行数を選択してください。',
        icon: 'question',
        showCancelButton: true,
        input: 'select',
        inputOptions: inputOptions,
        inputValue: '0',
        confirmButtonText: 'ダウンロード',
        cancelButtonText: 'キャンセル',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      });
    },
    async downloadExcel(rowCount) {
      const res = await axios.get(
        route('shifts.download-excel', {
          year: this.year,
          month: this.month,
          office: this.officeId,
          team_id: this.teamId,
          blank_row_count: rowCount,
        }),
        {
          responseType: 'blob',
        }
      );
      let elem = document.createElement('a');
      elem.href = window.URL.createObjectURL(new Blob([res.data]));

      const fileName = `シフト表_${this.officeName}_${this.teamName}_${this.year}${this.month}.xlsx`;
      elem.setAttribute('download', fileName);
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    },
    swalErrorAlert() {
      this.$swal({
        icon: 'error',
        text: 'エラーが発生しました。再度お試しください。',
      });
    },
  },
};
</script>

<style scoped>
.icon-style {
  color: #0bb0be;
  vertical-align: text-top;
  padding-right: 5px;
}
</style>
